export default "__VITE_ASSET__DbZ$58ka__"